/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const iconHeadlineStyle ={
  image: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
    width: "70px",
    height: "70px",
    "& > img": {
      maxHeight: "40px",
    },
  },
  contentName: {
    fontSize: "1.25rem",
    color: "text.primary",
    fontWeight: 400,
  },
  headlineContainer: {
    marginBottom: "10px",
  },
};

export default iconHeadlineStyle;
